import {AfterViewInit, Component, HostListener, OnInit, ViewChild, ViewContainerRef, inject, DestroyRef} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AutomaticLogoutPopupComponent } from './components/automatic-logout-popup/automatic-logout-popup.component';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FabricService } from './services/fabric/fabric.service';
import { SolutionsService } from './services/api/solutions.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  userActivity;
  userExpiry;
  userInactive: Subject<any> = new Subject();
  data: any;
  private destroyRef = inject(DestroyRef);
 
  constructor(public router: Router, public authService: AuthService, public dialog: MatDialog, private fabricService: FabricService, public solutionsService: SolutionsService){
    
    this.fabricService.refreshClaimsToken();
    this.fabricService.expiryInactive.pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if(typeof(data) === 'number') {
      this.data = data;
      this.userExpiry = setTimeout(
        () => this.userInactive.next('session'),
        Number(this.data)
      );
      }
    });
   
    this.setTimeout();
      this.userInactive.subscribe((data) => {
        let messageInactive =  (data === 'session') ? translate('AUTOMATIC_LOGOUT.MESSAGE_EXPIRED') : translate('AUTOMATIC_LOGOUT.MESSAGE_INACTIVE');
        this.dialog.open(AutomaticLogoutPopupComponent, {
          disableClose: true,
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('AUTOMATIC_LOGOUT.TITLE'),
            messageInactive: messageInactive,
            messageSecurity: translate('AUTOMATIC_LOGOUT.MESSAGE_SECURITY'),
            confirmButtonText: translate('AUTOMATIC_LOGOUT.CONTINUE')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((confirm) => {
            if(data === 'session') {
              this.fabricService.refreshClaimsToken();
            }
          })
        });
  }
 
  setTimeout() {
    if(Number(this.data) > 300000) {
      this.userActivity = setTimeout(
        () => this.userInactive.next(undefined),
        300000
      );
    }
  }
  @HostListener('window:mousemove') mouseMove() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('document:keydown', ['$event']) keyboardClick() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

ngOnInit(): void {
  console.log(`Version: ${environment.appVersion}`);
  if (this.authService.assignedPermissions && this.authService.assignedPermissions?.length !== 0) {
    // removed previous functionality to open tenant view if closed from tenant view and defaulted tenant view after login
    if (window.location.pathname?.split('/')?.length === 2) {
      this.router.navigate(['/', this.authService.principal.provider, 'tenant']);
    }
  }
  }
}